import patchAccountableBankingOnboarding from 'api/v2/transactions/patchAccountableBankingOnboarding';
import { useMutation } from 'react-query';

const useInitiateAccountableBankingOnboarding = () => {
  return useMutation(patchAccountableBankingOnboarding);
};

export default useInitiateAccountableBankingOnboarding;
